import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import { ContentTable } from "./ContentTable";
import { useSelector, useDispatch } from "react-redux";
import {
  getListHopDongDelete,
  updateDataSearch,
} from "../../../actions/DanhSachHopDongDelete";
import { formatNumber } from "utils/currencyFormat";
import { formatCurrency } from "utils/currencyFormat";

export const TableDanhSach = ({ quyenXoa }) => {
  const dispatch = useDispatch();
  const listHopDongDeleteFull = useSelector(
    (state) => state.listDanhSachHopDongDeleteFull
  );
  const dataSearch = useSelector((state) => state.dataSearchHopDongDelete);

  useEffect(() => {
    dispatch(getListHopDongDelete(dataSearch));
  }, []);

  const loadTaiSan = () => {
    getListHopDongDelete(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }; // set lên đầu page ví dụ khi phân trang

  const handlePageChange = (pageNumber) => {
    dataSearch.pageIndex = pageNumber;
    dispatch(
      updateDataSearch({
        ...dataSearch,
        pageIndex: pageNumber,
      })
    );
    dispatch(getListHopDongDelete(dataSearch));
    loadTaiSan(dataSearch);
    //setpageNumber(pageNumber);
  };
  const TotalQuantity = listHopDongDeleteFull.SoHopDong;

  return (
    <>
      <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="Left808x200 Table-main-new">
            <div className="table-mobile  table-mobile-hover">
              <div className="custom-table-wrapper">
                <div className="table-headers">
                  <div className="custom-table-header flex-basis-8 flex-basis-6-sm">
                    <p className="text-center">
                      STT
                      <br />{" "}
                      <span className="color-do-bold">
                        [ {listHopDongDeleteFull.SoHopDong} ]
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-17 flex-basis-12-8-sm">
                    <p>Tên khách hàng</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-15-6-sm">
                    <p className="text-center">Mã cho vay</p>
                  </div>
                  <div className="custom-table-header flex-basis-17 flex-basis-17-8-sm">
                    <p className="text-right">
                      Số tiền vay
                      <br />{" "}
                      <span className="color-do-bold" title={formatNumber(listHopDongDeleteFull.TongTien)}>
                        {formatCurrency(listHopDongDeleteFull.TongTien)}
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-12 flex-basis-9-2-sm">
                    <p className="text-center">Ngày vay</p>
                  </div>
                  <div className="custom-table-header flex-basis-12 flex-basis-15-sm">
                    <p className="text-left">Người xóa</p>
                  </div>

                  <div className="custom-table-header flex-basis-13 flex-basis-15-sm">
                    <p className="text-center">Ngày xoá</p>
                  </div>

                  <div className="custom-table-header flex-basis-11 flex-basis-8-6-sm">
                    <p className="tab-header">Chức năng</p>
                  </div>
                </div>

                <div className="custom-table-body">
                  <ContentTable
                    listHopDongDeleteFull={listHopDongDeleteFull}
                    quyenXoa={quyenXoa}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="row">
            <div className="col-sm-12 col-md-6">
              <span className="color7">
                {TotalQuantity === 0 ? (
                  "Hiển thị 0 - 0 / Tổng số 0"
                ) : (
                  <>
                    Hiển thị{" "}
                    {(dataSearch.pageIndex - 1) * dataSearch.pageSize + 1} -{" "}
                    {Math.min(
                      dataSearch.pageIndex * dataSearch.pageSize,
                      TotalQuantity
                    )}{" "}
                    / Tổng số {TotalQuantity}
                  </>
                )}
              </span>
            </div>
            <div className="col-sm-12 col-md-6">
              <div
                className={
                  "paniation-new paniation-new1 d-flex justify-content-center " +
                  (TotalQuantity === 0 ? "hidden" : "")
                }
                style={{ float: "right" }}
              >
                <nav aria-label="Page navigation">
                  <Pagination
                    activePage={dataSearch.pageIndex}
                    itemsCountPerPage={dataSearch.pageSize}
                    totalItemsCount={TotalQuantity}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    itemClass="page-item border-none"
                    linkClass="page-link border-none"
                    activeClass="active"
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
